module.exports = __webpack_public_path__ + "img/login_img.f8353726.png";